import { Home } from '../components/pages/home/Home';
import { About } from '../components/pages/about/About';
import { Contact } from '../components/pages/contact/Contact';
import { Projects } from '../components/pages/projects/Projects';
import { Hiking } from '../components/pages/projects/hiking/Hiking';
import { Trekking } from '../components/pages/projects/trekking/Trekking';
import { Tatry } from '../components/pages/projects/hiking/Tatry';
import { Malaga } from '../components/pages/projects/hiking/Malaga';
import { Madera } from '../components/pages/projects/hiking/Madera';
import PrivacyPolicy from '../components/pages/PrivacyPolicy';
import EmailConfirmation from '../components/pages/EmailConfirmation';
import { Tatry2 } from '../components/pages/projects/hiking/Tatry2';
import { Dymin } from '../components/pages/projects/hiking/Dymin';
import { Szkocja } from '../components/pages/projects/hiking/Szkocja';
import { Karkonosze } from '../components/pages/projects/hiking/Karkonosze';
import { Portugalia2026 } from '../components/pages/projects/hiking/Portugalia2026';
import { Slowacja2026 } from '../components/pages/projects/hiking/Slowacja2026';
import { Rumunia2026 } from '../components/pages/projects/hiking/Rumunia2026';
import { Dymin2026 } from '../components/pages/projects/hiking/Dymin2026';
import { GoryStolowe2026 } from '../components/pages/projects/hiking/GoryStolowe2026';
import { FAQ } from '../components/pages/faq/FAQ';

interface Route {
  title: string;
  href: string;
  component: React.ComponentType;
  showInNav: boolean;
}

export const routes: Route[] = [
  {
    title: 'nav.confirmEmail',
    href: '/confirm',
    component: EmailConfirmation,
    showInNav: false,
  },
  {
    title: 'nav.home',
    href: '/',
    component: Home,
    showInNav: true,
  },
  {
    title: 'nav.about',
    href: '/about',
    component: About,
    showInNav: true,
  },
  {
    title: 'nav.trekking',
    href: '/projects/trekking',
    component: Trekking,
    showInNav: true,
  },
  {
    title: 'nav.hiking',
    href: '/projects/hiking',
    component: Hiking,
    showInNav: true,
  },
  {
    title: 'nav.projects',
    href: '/projects',
    component: Projects,
    showInNav: false,
  },
  {
    title: 'nav.contact',
    href: '/contact',
    component: Contact,
    showInNav: true,
  },
  {
    title: 'nav.faq',
    href: '/faq',
    component: FAQ,
    showInNav: true,
  },

  {
    title: 'nav.tatry',
    href: '/projects/hiking/tatry',
    component: Tatry,
    showInNav: false,
  },
  {
    title: 'nav.malaga',
    href: '/projects/hiking/malaga',
    component: Malaga,
    showInNav: false,
  },
  {
    title: 'nav.madera',
    href: '/projects/hiking/madera',
    component: Madera,
    showInNav: false,
  },
  {
    title: 'nav.tatry2',
    href: '/projects/hiking/tatry2',
    component: Tatry2,
    showInNav: false,
  },
  {
    title: 'nav.dymin',
    href: '/projects/hiking/dymin',
    component: Dymin,
    showInNav: false,
  },
  {
    title: 'nav.szkocja',
    href: '/projects/hiking/szkocja',
    component: Szkocja,
    showInNav: false,
  },
  {
    title: 'nav.karkonosze',
    href: '/projects/hiking/karkonosze',
    component: Karkonosze,
    showInNav: false,
  },
  {
    title: 'nav.portugalia2026',
    href: '/projects/hiking/2026/portugalia',
    component: Portugalia2026,
    showInNav: false,
  },
  {
    title: 'nav.slowacja2026',
    href: '/projects/hiking/2026/slowacja',
    component: Slowacja2026,
    showInNav: false,
  },
  {
    title: 'nav.rumunia2026',
    href: '/projects/hiking/2026/rumunia',
    component: Rumunia2026,
    showInNav: false,
  },
  {
    title: 'nav.dymin2026',
    href: '/projects/hiking/2026/dymin',
    component: Dymin2026,
    showInNav: false,
  },
  {
    title: 'nav.goryStolowe2026',
    href: '/projects/hiking/2026/gory-stolowe',
    component: GoryStolowe2026,
    showInNav: false,
  },

  {
    title: 'nav.policy',
    href: '/policy',
    component: PrivacyPolicy,
    showInNav: false,
  },
];
